import { EuiSpacer } from "@inscopix/ideas-eui";
import { ButtonDeleteTables } from "components/ProjectTablesTable/ButtonDeleteTables";
import { ProjectTablesSearchAndFilter } from "components/ProjectTablesTable/ProjectTablesSearchAndFilter";
import { ProjectTablesTable } from "components/ProjectTablesTable/ProjectTablesTable";
import { ButtonCreateTable } from "pages/gdt/layout/ButtonCreateTable";
import { ButtonMoveTables } from "components/ProjectTablesTable/ButtonMoveFolder";
import { useProjectTablesTableContext } from "./provider/ProjectTablesTableProvider";
import { shallow } from "zustand/shallow";
import { useProjectPermissionStore } from "pages/project/ProjectPermissionProvider";
import { ProjectTablesModals } from "./ProjectTablesModals";

export const ProjectTablesTableLayout = () => {
  const anyVisibleTableIsSelected = useProjectTablesTableContext(
    (s) => s.getAnyVisibleTableIsSelected(),
    shallow,
  );
  const canEdit = useProjectPermissionStore((s) => s.permissions.edit);

  return (
    <>
      <ProjectTablesSearchAndFilter />
      <EuiSpacer size="m" />
      <ProjectTablesTable />
      <EuiSpacer size="m" />
      {canEdit && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "16px",
          }}
        >
          {!anyVisibleTableIsSelected && <ButtonCreateTable />}
          {anyVisibleTableIsSelected && (
            <>
              <ButtonMoveTables />
              <EuiSpacer />
              <ButtonDeleteTables />
            </>
          )}
        </div>
      )}
      <ProjectTablesModals />
    </>
  );
};
